<template>
    <!--首页-->
    <div class="box" v-loading="loading">
        <headerbox :focus="0" v-show="shos"></headerbox>
        <swiper :options="swiperOption" style="min-height: 660px"
                ref="mySwiper">
            <swiper-slide>
                <transition name="slide-fade">
                    <div class="slide1" v-show="active==0">
                        <div class="imgbox">
                            <img src="../../public/statics/img/banner.gif" alt="">
                        </div>
                        <div class="indexfont"
                             v-show="slide1anmate.animate8==1||slide1anmate.animate8==2"
                             :class="['animated',slide1anmate.animate8==1?'fadeInUpBig':'',slide1anmate.animate8==2?'fadeInDownBig':'']"
                        >
                            <img src="../../public/statics/img/indexfont.png" alt="">
                        </div>
                      <!--         <div class="apply"
                             v-if="slide1anmate.animate1==1||slide1anmate.animate1==2"
                             :class="['animated',slide1anmate.animate1==1?'fadeInUpBig':'',slide1anmate.animate1==2?'fadeInDownBig':'']"
                             @click="toapply()"
                        >申请入驻 <i class="el-icon-arrow-right"></i></div>-->
                        <div class="applys"
                             v-if="slide1anmate.animate1==1||slide1anmate.animate1==2"
                             :class="['animated',slide1anmate.animate1==1?'fadeInUpBig':'',slide1anmate.animate1==2?'fadeInDownBig':'']"
                             @click="toapply()">
                            <img src="../../public/statics/img/apply.png" alt="">
                        </div>
                        <div class="slide1bot"
                             v-show="slide1anmate.animate7==1||slide1anmate.animate7==2"
                             :class="['animated',slide1anmate.animate7==1?'fadeInUpBig':'',slide1anmate.animate7==2?'fadeInDownBig':'']"
                        ></div>
                        <div class="slide1bots">
                            <div class="slide1unit"
                                 v-show="slide1anmate.animate2==1||slide1anmate.animate2==2"
                                 :class="['animated',slide1anmate.animate2==1?'fadeInUpBig':'',slide1anmate.animate2==2?'fadeInDownBig':'']">
                                <p>商业SaaS+交易平台</p>
                                <span>Bussiness SaaS</span>
                            </div>
                            <div class="slide1white"
                                 v-show="slide1anmate.animate3==1||slide1anmate.animate3==2"
                                 :class="['animated',slide1anmate.animate3==1?'fadeInUpBig':'',slide1anmate.animate3==2?'fadeInDownBig':'']"
                            ></div>
                            <div class="slide1unit"
                                 v-show="slide1anmate.animate4==1||slide1anmate.animate4==2"
                                 :class="['animated',slide1anmate.animate4==1?'fadeInUpBig':'',slide1anmate.animate4==2?'fadeInDownBig':'']">
                                <p>全场景</p>
                                <span>Full scene</span>
                            </div>
                            <div class="slide1white"
                                 v-show="slide1anmate.animate5==1||slide1anmate.animate5==2"
                                 :class="['animated',slide1anmate.animate5==1?'fadeInUpBig':'',slide1anmate.animate5==2?'fadeInDownBig':'']"></div>
                            <div class="slide1unit"
                                 v-show="slide1anmate.animate6==1||slide1anmate.animate6==2"
                                 :class="['animated',slide1anmate.animate6==1?'fadeInUpBig':'',slide1anmate.animate6==2?'fadeInDownBig':'']">
                                <p>一体化</p>
                                <span>Integration</span>
                            </div>
                        </div>
                    </div>
                </transition>
            </swiper-slide>

            <swiper-slide>
                <transition name="slide-fade">
                    <div class="sldie2" v-show="active==1">
                        <div class="slide2font">
                            <div class="sl2black"
                                 v-show="slide2anmate.animate1==1||slide2anmate.animate1==2"
                                 :class="['animated',slide2anmate.animate1==1?'fadeInUpBig':'',slide2anmate.animate1==2?'fadeInDownBig':'']"></div>
                            <div class="sl2title"
                                 v-show="slide2anmate.animate2==1||slide2anmate.animate2==2"
                                 :class="['animated',slide2anmate.animate2==1?'fadeInUpBig':'',slide2anmate.animate2==2?'fadeInDownBig':'']">
                                商业SaaS+交易平台
                            </div>
                            <div class="sl2titles"
                                 v-show="slide2anmate.animate3==1||slide2anmate.animate3==2"
                                 :class="['animated',slide2anmate.animate3==1?'fadeInUpBig':'',slide2anmate.animate3==2?'fadeInDownBig':'']">
                                IDA不仅仅是一个高效的管理工具。IDA在满足用户管理赋能的同时，为用户实现市场赋能。
                                IDA利用平台整合效应，充分链接外部平台产业资源和物流资源，为3PL和车主拓展市场，获取海量订单。
                            </div>
                            <div class="sl2details"
                                 v-show="slide2anmate.animate4==1||slide2anmate.animate4==2"
                                 :class="['animated',slide2anmate.animate4==1?'fadeInUpBig':'',slide2anmate.animate4==2?'fadeInDownBig':'']">
                                IDA is more than an efficient management tool. Ida not only satisfies the user
                                management empowerment, but also realizes market empowerment for users.
                                Ida takes advantage of the platform integration effect, fully links the external
                                platform industry resources and logistics resources, expands the market for 3PL and car
                                owners, and obtains massive orders.
                            </div>
                        </div>
                        <div class="slide2img">
                        </div>
                    </div>
                </transition>
            </swiper-slide>
            <swiper-slide>
                <transition name="slide-fade">
                    <div class="slide3" v-show="active==2">
                        <div class="slide3img">
                            <img src="../../public/statics/img/index/all.jpg" alt="">
                        </div>
                        <div class="slide3font">
                            <div class="slide3fonts"
                                 style="margin-right: 0.5rem;">
                                <div class="slide3back"
                                     v-show="slide3anmate.animate1==1||slide3anmate.animate1==2"
                                     :class="['animated',slide3anmate.animate1==1?'fadeInUpBig':'',slide3anmate.animate1==2?'fadeInDownBig':'']"
                                ></div>
                                <div class="slide3title"
                                     v-show="slide3anmate.animate2==1||slide3anmate.animate2==2"
                                     :class="['animated',slide3anmate.animate2==1?'fadeInUpBig':'',slide3anmate.animate2==2?'fadeInDownBig':'']">
                                    全物流场景操作
                                </div>
                            </div>
                            <div class="slide3fonts">
                                <div class="slide3titles"
                                     v-show="slide3anmate.animate3==1||slide3anmate.animate3==2"
                                     :class="['animated',slide3anmate.animate3==1?'fadeInUpBig':'',slide3anmate.animate3==2?'fadeInDownBig':'']">
                                    IDA满足用户整车、零担、配送、陆运、空运、海运及多联式物流业务需求。
                                    随着供应链全场景物流时代的来临，IDA云平台打破传统TMS的单一运输场景模式，聚焦于用户的全物流业务服务场景。
                                </div>
                                <div class="slide3details"
                                     v-show="slide3anmate.animate4==1||slide3anmate.animate4==2"
                                     :class="['animated',slide3anmate.animate4==1?'fadeInUpBig':'',slide3anmate.animate4==2?'fadeInDownBig':'']">
                                    Ida meets the needs of customers for complete vehicle, less than carload,
                                    distribution, land transportation, air transportation, sea transportation and multi
                                    joint logistics business. With the advent of the era of full scene logistics in the
                                    supply chain, IDA cloud platform breaks the single transportation scenario mode of
                                    traditional TMS and focuses on the user's full logistics business service scenario.
                                </div>
                            </div>

                        </div>
                    </div>
                </transition>
            </swiper-slide>
            <swiper-slide>
                <transition name="slide-fade">
                    <div class="slide4" v-show="active==3">
                        <div class="slide4img">
                            <swiper :options="swiperOption1"
                                    ref="mySwiper1" class="banner">
                                <swiper-slide class="bannerunit">
                                    <img src="../../public/statics/img/index/bannner2.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide class='bannerunit'>
                                    <img src="../../public/statics/img/index/bannner1.jpg" alt="">
                                </swiper-slide>
                                <swiper-slide class="bannerunit">
                                    <img src="../../public/statics/img/index/banner3.jpg" alt="">
                                </swiper-slide>
                                <div class="swiper-button-prev" slot="button-prev">
                                    <img src="../../public/statics/img/index/left.png" alt="">
                                </div>
                                <div class="swiper-button-next" slot="button-next">
                                    <img src="../../public/statics/img/index/right.png" alt="">
                                </div>
                            </swiper>


                        </div>
                        <div class="slide4font">
                            <div class="slide4black"
                                 v-show="slide4anmate.animate1==1||slide4anmate.animate1==2"
                                 :class="['animated',slide4anmate.animate1==1?'fadeInUpBig':'',slide4anmate.animate1==2?'fadeInDownBig':'']"></div>
                            <div class="slide4title"
                                 v-show="slide4anmate.animate2==1||slide4anmate.animate2==2"
                                 :class="['animated',slide4anmate.animate2==1?'fadeInUpBig':'',slide4anmate.animate2==2?'fadeInDownBig':'']">
                                一体化物流管理
                            </div>
                            <div class="slide4titles"
                                 v-show="slide4anmate.animate3==1||slide4anmate.animate3==2"
                                 :class="['animated',slide4anmate.animate3==1?'fadeInUpBig':'',slide4anmate.animate3==2?'fadeInDownBig':'']">
                                IDA无缝实现仓储、运输、包装环节的EDI数据交互。
                                IDA把TMS/WMS/CMS整合在一个平台，实现运输、仓储、包装的信息化闭环管理；让用户充分享受协同、高效带来的管理应用价值。
                            </div>
                            <div class="slide4details"
                                 v-show="slide4anmate.animate4==1||slide4anmate.animate4==2"
                                 :class="['animated',slide4anmate.animate4==1?'fadeInUpBig':'',slide4anmate.animate4==2?'fadeInDownBig':'']">
                                Ida seamlessly realizes EDI data interaction in warehousing, transportation and
                                packaging.
                                Ida integrates TMS / WMS / CMS into one platform to realize the information closed-loop
                                management of transportation, storage and packaging; Let users fully enjoy the value of
                                collaborative and efficient management applications.
                            </div>
                        </div>
                    </div>
                </transition>
            </swiper-slide>
            <swiper-slide>
                <transition name="slide-fade">
                    <div class="sldie2" v-show="active==4">
                        <div class="slide2font">
                            <div class="sl2black"
                                 v-show="slide5anmate.animate1==1||slide5anmate.animate1==2"
                                 :class="['animated',slide5anmate.animate1==1?'fadeInUpBig':'',slide5anmate.animate1==2?'fadeInDownBig':'']"></div>
                            <div class="sl2title"
                                 v-show="slide5anmate.animate2==1||slide5anmate.animate2==2"
                                 :class="['animated',slide5anmate.animate2==1?'fadeInUpBig':'',slide5anmate.animate2==2?'fadeInDownBig':'']">
                                5G+IoT技术应用
                            </div>
                            <div class="sl2titles"
                                 v-show="slide5anmate.animate3==1||slide5anmate.animate3==2"
                                 :class="['animated',slide5anmate.animate3==1?'fadeInUpBig':'',slide5anmate.animate3==2?'fadeInDownBig':'']">
                                IDA真正实现物流全程无断点货物跟踪。
                                IDA充分运用5G和IoT技术，通过手机APP、GPS设备、智能硬件，使整个运输过程透明可见，让用户真实体会到“运筹帷幄，决胜千里”的管理体验。
                            </div>
                            <div class="sl2details"
                                 v-show="slide5anmate.animate4==1||slide5anmate.animate4==2"
                                 :class="['animated',slide5anmate.animate4==1?'fadeInUpBig':'',slide5anmate.animate4==2?'fadeInDownBig':'']">
                                Ida truly realizes goods tracking without breakpoints in the whole logistics process.
                                Ida makes full use of 5g and IoT technology to make the whole transportation process
                                transparent and visible through mobile app, GPS equipment and intelligent hardware, so
                                that users can truly experience the management experience of "strategizing and winning a
                                thousand miles".
                            </div>
                        </div>
                        <div class="slide2imgs">
                        </div>
                    </div>
                </transition>
            </swiper-slide>
            <swiper-slide>
                <transition name="slide-fade">
                    <div class="slide3" v-show="active==5">
                        <div class="slide3imgs">
                            <img src="../../public/statics/img/index/web.jpg" alt="">
                        </div>
                        <div class="slide3font">
                            <div class="slide3fonts" style="margin-right: 0.5rem;">
                                <div class="slide3back"
                                     v-show="slide6anmate.animate1==1||slide6anmate.animate1==2"
                                     :class="['animated',slide6anmate.animate1==1?'fadeInUpBig':'',slide6anmate.animate1==2?'fadeInDownBig':'']"></div>
                                <div class="slide3title"
                                     v-show="slide6anmate.animate2==1||slide6anmate.animate2==2"
                                     :class="['animated',slide6anmate.animate2==1?'fadeInUpBig':'',slide6anmate.animate2==2?'fadeInDownBig':'']">
                                    移动终端全覆盖
                                </div>

                            </div>
                            <div class="slide3fonts">
                                <div class="slide3titles"
                                     v-show="slide6anmate.animate3==1||slide6anmate.animate3==2"
                                     :class="['animated',slide6anmate.animate3==1?'fadeInUpBig':'',slide6anmate.animate3==2?'fadeInDownBig':'']">
                                    IDA实现物流现场操作数据的实时同步。
                                    IDA通过移动终端将3PL现场人员、货主、车主和收货人实现操作信息实时同步，打破传统信息壁垒，使整个物流过程透明化，方便多方同步高效决策。
                                </div>
                                <div class="slide3details"
                                     v-show="slide6anmate.animate4==1||slide6anmate.animate4==2"
                                     :class="['animated',slide6anmate.animate4==1?'fadeInUpBig':'',slide6anmate.animate4==2?'fadeInDownBig':'']">
                                    Ida realizes the real-time synchronization of logistics field operation data.
                                    Ida realizes real-time synchronization of 3PL on-site personnel, cargo owners,
                                    vehicle owners and consignees through mobile terminals, breaks traditional
                                    information barriers, makes the whole logistics process transparent, and facilitates
                                    multi-party synchronous and efficient decision-making.
                                </div>
                            </div>

                        </div>
                    </div>
                </transition>
            </swiper-slide>
            <swiper-slide>
                <transition name="slide-fade">
                    <div class="slide4" v-show="active==6">
                        <div class="slide4imgs"></div>
                        <div class="slide4font">
                            <div class="slide4black"
                                 v-show="slide7anmate.animate1==1||slide7anmate.animate1==2"
                                 :class="['animated',slide7anmate.animate1==1?'fadeInUpBig':'',slide7anmate.animate1==2?'fadeInDownBig':'']"></div>
                            <div class="slide4title"
                                 v-show="slide7anmate.animate2==1||slide7anmate.animate2==2"
                                 :class="['animated',slide7anmate.animate2==1?'fadeInUpBig':'',slide7anmate.animate2==2?'fadeInDownBig':'']">
                                IT-DT-AI设计理念
                            </div>
                            <div class="slide4titles"
                                 v-show="slide7anmate.animate3==1||slide7anmate.animate3==2"
                                 :class="['animated',slide7anmate.animate3==1?'fadeInUpBig':'',slide7anmate.animate3==2?'fadeInDownBig':'']">
                                IDA协助用户逐步实现物流管理从IT(信息化)到DT(大数据)、AI(智能化)的转型升级。
                                IDA采用先进的产品开发技术和创新理念，利用行业领先的数据架构、AI算法、智能硬件，重塑物流管理模式，全方位助力用户实现物流数字化和智能化升级。
                            </div>
                            <div class="slide4details"
                                 v-show="slide7anmate.animate4==1||slide7anmate.animate4==2"
                                 :class="['animated',slide7anmate.animate4==1?'fadeInUpBig':'',slide7anmate.animate4==2?'fadeInDownBig':'']">
                                Ida helps users gradually realize the transformation and upgrading of logistics
                                management from it informatization to DT big data and AI intelligence.
                                Ida uses advanced product development technology and innovative ideas, uses
                                industry-leading data architecture, AI algorithm and intelligent hardware to reshape the
                                logistics management mode, and comprehensively helps users to realize logistics
                                digitization and intelligent upgrading.
                            </div>
                        </div>
                    </div>
                </transition>
            </swiper-slide>

            <swiper-slide>
                <transition name="slide-fade">
                    <div class="news" v-show="active==7">
                        <div v-show="newsactive.title1==1"
                             :class='["title",newsactive.title1==1 ? "animated fadeInUpBig " : ""]'>咨讯动态
                        </div>
                        <div
                                v-show="newsactive.title2==1"
                                :class='["titles",newsactive.title2==1 ? "animated fadeInUpBig " : ""]'>NEWS
                        </div>
                        <div class="newsb">
                            <div v-show="newsactive.title3==1"
                                 :class='["newsbl",newsactive.title3==1 ? "animated fadeInUpBig " : ""]'>
                                <div class="newblimgbox">
                                    <img src="../../public/statics/img/newlist/8.27/01.jpg" alt="">
                                </div>
                                <div class="newbllist" style="cursor: pointer" @click="jumpdetail(9)">
                                    <div class="newbllist1">
                                        <p>{{newdata[0].time.year}}</p>
                                        <div class="newbllist1s"></div>
                                        <span>{{newdata[0].time.month}}-{{newdata[0].time.day}}</span>
                                    </div>
                                    <div class="newbllist2">
                                        <p>{{newdata[0].title}}</p>
                                        <span>{{newdata[0].content}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="newsbr">
                                <div style="cursor: pointer"  v-show="newsactive.title3==1" @click="jumpdetail(8)"
                                     :class='["newsbrunit",newsactive.title3==1 ? "animated fadeInUpBig " : ""]'>
                                    <div class="newbllist1">
                                        <p>{{newdata[1].time.year}}</p>
                                        <div class="newbllist1s"></div>
                                        <span>{{newdata[1].time.month}}-{{newdata[1].time.day}}</span>
                                    </div>
                                    <div class="newbllist2">
                                        <p>{{newdata[1].title}}</p>
                                        <span>{{newdata[1].content}}</span>
                                    </div>
                                </div>
                                <div style="cursor: pointer" v-show="newsactive.title4==1" @click="jumpdetail(7)"
                                     :class='["newsbrunit",newsactive.title4==1 ? "animated fadeInUpBig " : ""]'>
                                    <div class="newbllist1">
                                        <p>{{newdata[2].time.year}}</p>
                                        <div class="newbllist1s"></div>
                                        <span>{{newdata[2].time.month}}-{{newdata[2].time.day}}</span>
                                    </div>
                                    <div class="newbllist2">
                                        <p>{{newdata[2].title}}</p>
                                        <span>{{newdata[2].content}}</span>
                                    </div>
                                </div>
                                <div style="cursor: pointer" v-show="newsactive.title5==1" @click="jumpdetail(6)"
                                     :class='["newsbrunit",newsactive.title5==1 ? "animated fadeInUpBig " : ""]'>
                                    <div class="newbllist1">
                                        <p>{{newdata[3].time.year}}</p>
                                        <div class="newbllist1s"></div>
                                        <span>{{newdata[3].time.month}}-{{newdata[3].time.day}}</span>
                                    </div>
                                    <div class="newbllist2">
                                        <p>{{newdata[3].title}}</p>
                                        <span>{{newdata[3].content}}</span>
                                    </div>
                                </div>
                                <div style="cursor: pointer" v-show="newsactive.title6==1" @click="jumpdetail(5)"
                                     :class='["newsbrunit",newsactive.title6==1 ? "animated fadeInUpBig " : ""]'>
                                    <div class="newbllist1">
                                        <p>{{newdata[4].time.year}}</p>
                                        <div class="newbllist1s"></div>
                                        <span>{{newdata[4].time.month}}-{{newdata[4].time.day}}</span>
                                    </div>
                                    <div class="newbllist2">
                                        <p>{{newdata[4].title}}</p>
                                        <span>{{newdata[4].content}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div v-show="newsactive.title7==1"
                             :class='["more",newsactive.title7==1 ? "animated fadeInUpBig " : ""]'
                             @click="tojumpnews()">
                            MORE
                        </div>
                    </div>
                </transition>

                <div class="bottoms">
                    <img src="../../public/statics/img/bottom.png" alt="">
                    <div class="botnic">
                        <div class="botsbut">
                            <div class="botsbut1" @click="toapply()">申请入驻</div>
                            <!--                            <div class="botsbut2">版本比较</div>-->
                        </div>
                        <p class="botsfont">
                            © 2021 All Rights Reserved 苏州量子方舟网络科技有限公司 版权所有 <span class="bottomSpans">
                     <a href="https://beian.miit.gov.cn/" style="">苏ICP备18053448号-2</a>
                </span>
                        </p>
                    </div>

                </div>
            </swiper-slide>
            <!-- <div class="swiper-pagination"  slot="pagination"></div>-->
            <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
    </div>

</template>


<script>

    import {auth, anth} from '../request/api';
    import {mapGetters, mapState} from "vuex";
    import headerbox from "../components/boxtop";
    import news from "../../public/statics/newsdata"

    export default {
        name: "index",
        data() {
            return {
                loading: true,
                laji: "",
                shos: true,
                active: 0,
                slide1anmate: {
                    animate1: 0,
                    animate2: 0,
                    animate3: 0,
                    animate4: 0,
                    animate5: 0,
                    animate6: 0,
                    animate7: 0,
                    animate8: 0,
                },
                slide2anmate: {
                    animate1: 0,
                    animate2: 0,
                    animate3: 0,
                    animate4: 0,
                },
                slide3anmate: {
                    animate1: 0,
                    animate2: 0,
                    animate3: 0,
                    animate4: 0,
                },
                slide4anmate: {
                    animate1: 0,
                    animate2: 0,
                    animate3: 0,
                    animate4: 0,
                },
                slide5anmate: {
                    animate1: 0,
                    animate2: 0,
                    animate3: 0,
                    animate4: 0,
                },
                slide6anmate: {
                    animate1: 0,
                    animate2: 0,
                    animate3: 0,
                    animate4: 0,
                },
                slide7anmate: {
                    animate1: 0,
                    animate2: 0,
                    animate3: 0,
                    animate4: 0,
                },
                newsactive: {
                    title1: 0,
                    title2: 0,
                    title3: 0,
                    title4: 0,
                    title5: 0,
                    title6: 0,
                    title7: 0,
                },


                swiperOption: {
                    loop: false,
                    speed: 1500,
                    direction: 'vertical',
                    slidesPerView: 1,
                    spaceBetween: 0,
                    mousewheel: true,
                    sensitivity: 0.5,
                    autoHeight: true,
                    height: window.innerHeight,
                    /*   pagination: {
                          el: '.swiper-pagination',
                          clickable: true
                      },*/
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                        thresholdTime: 2000,//时间
                        // thresholdDelta:110,//距离
                    },
                    observer: true,//修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true,//修改swiper的父元素时，自动初始化swiper

                    watchSlidesProgress: true,
                    on: {
                        slideChange: () => {
                            this.animate();
                        },
                    },
                },
                swiperOption1: {
                    loop: true,
                    autoplay: {
                        delay: 1500,
                        stopOnLastSlide: false,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                },

                newdata: [],

            }
        },
        components: {
            headerbox,
        },
        created() {
            let arr = news.newslist.slice(0, 5);
            this.newdata = JSON.parse(JSON.stringify(arr));
        },
        mounted() {
            setTimeout(() => {
                this.loading = false;
            }, 200);
            this.animate();

        },
        computed: {
            ...mapState(["name", "msg"]),
            swiper() {
                return this.$refs.mySwiper.swiper
            },
            swiper1() {
                return this.$refs.mySwiper1.swiper
            }
        },
        methods: {
            tojumpnews() {
                this.$router.push({
                    path: '/newviews'
                })
            },
            toapply() {
                this.$router.push({
                    path: '/edition'
                })
            },
            /*   set() {
                   let str = '刘煦';
                   this.$store.commit('UPDATE_NAME', JSON.parse(JSON.stringify(str)))
                   console.log(this.$store.state.name);
               },
               set1() {
                   let str = '老刘';
                   this.$store.commit('UPDATE_NAME', JSON.parse(JSON.stringify(str)))
                   console.log(this.$store.state.name);
               },
               sub() {

               },*/

            //整个动画效果
            animate() {
                let swiper = this.$refs.mySwiper.swiper;
                let i = swiper.activeIndex;


                if (this.active <= i) {
                    // console.log(this.active, swiper.activeIndex, '999');
                    if (i == 0) {
                        this.active = 0;
                        this.firstanimate();
                    }
                    if (i == 1) {
                        this.active = i;
                        this.slide2animate()
                    } else if (i == 2) {
                        this.active = i;
                        this.slide3animate()
                    } else if (i == 3) {
                        this.active = i;
                        this.slide4animate()
                    } else if (i == 4) {
                        this.active = i;
                        this.slide5animate()
                    } else if (i == 5) {
                        this.active = i;
                        this.slide6animate()
                    } else if (i == 6) {
                        this.active = i;
                        this.slide7animate()
                    } else if (i == 7) {
                        this.active = 7;
                        this.newanimate();
                    }
                } else {
                    if (i == 0) {
                        this.active = i;
                        this.firstanimateback();
                    } else if (i == 1) {
                        this.active = i;
                        this.slide2animateback();
                    } else if (i == 2) {
                        this.active = i;
                        this.slide3animateback();
                    } else if (i == 3) {
                        this.active = i;
                        this.slide4animateback();
                    } else if (i == 4) {
                        this.active = i;
                        this.slide5animateback();
                    } else if (i == 5) {
                        this.active = i;
                        this.slide6animateback();
                    } else if (i == 6) {
                        this.active = i;
                        this.slide7animateback();
                    } else {
                        this.active = i;
                    }
                }

            },
            //slide1
            firstanimate() {
                setTimeout(() => {
                    this.slide1anmate.animate8 = 1;
                }, 200);
                setTimeout(() => {

                    this.slide1anmate.animate1 = 1;
                    this.slide1anmate.animate7 = 1;
                }, 400);
                setTimeout(() => {
                    this.slide1anmate.animate2 = 1;
                }, 600);
                setTimeout(() => {
                    this.slide1anmate.animate3 = 1;
                }, 800);
                setTimeout(() => {
                    this.slide1anmate.animate4 = 1;
                }, 1000);
                setTimeout(() => {
                    this.slide1anmate.animate5 = 1;
                }, 1200);
                setTimeout(() => {
                    this.slide1anmate.animate6 = 1;
                }, 1400);

                this.clearslide1();
            },
            firstanimateback() {
                this.clearslide1();

                setTimeout(() => {
                    this.slide1anmate.animate7 = 2;
                }, 200);

                setTimeout(() => {
                    this.slide1anmate.animate2 = 2;
                    this.slide1anmate.animate3 = 2;
                    this.slide1anmate.animate4 = 2;
                    this.slide1anmate.animate5 = 2;
                    this.slide1anmate.animate6 = 2;
                }, 400);
                setTimeout(() => {
                    this.slide1anmate.animate1 = 2;
                }, 600);
                setTimeout(() => {
                    this.slide1anmate.animate8 = 2;
                }, 800);

            },
            clearslide1() {
                this.slide1anmate.animate1 = 0;
                this.slide1anmate.animate2 = 0;
                this.slide1anmate.animate3 = 0;
                this.slide1anmate.animate4 = 0;
                this.slide1anmate.animate5 = 0;
                this.slide1anmate.animate6 = 0;
                this.slide1anmate.animate7 = 0;
                this.slide1anmate.animate8 = 0;
            },

            //slide2
            slide2animate() {
                setTimeout(() => {
                    this.slide2anmate.animate1 = 1;
                }, 200);
                setTimeout(() => {
                    this.slide2anmate.animate2 = 1;
                }, 400);
                setTimeout(() => {
                    this.slide2anmate.animate3 = 1;
                }, 600);
                setTimeout(() => {
                    this.slide2anmate.animate4 = 1;
                }, 800);
                this.clearslide2();
            },
            slide2animateback() {
                setTimeout(() => {
                    this.slide2anmate.animate1 = 2;
                }, 200);
                setTimeout(() => {
                    this.slide2anmate.animate2 = 2;
                }, 400);
                setTimeout(() => {
                    this.slide2anmate.animate3 = 2;
                }, 600);
                setTimeout(() => {
                    this.slide2anmate.animate4 = 2;
                }, 800);
                this.clearslide2();

            },
            clearslide2() {
                this.slide2anmate.animate1 = 0;
                this.slide2anmate.animate2 = 0;
                this.slide2anmate.animate3 = 0;
                this.slide2anmate.animate4 = 0;

            },
            //slide3
            slide3animate() {
                setTimeout(() => {
                    this.slide3anmate.animate1 = 1;
                }, 200);
                setTimeout(() => {
                    this.slide3anmate.animate2 = 1;
                }, 400);
                setTimeout(() => {
                    this.slide3anmate.animate3 = 1;
                }, 600);
                setTimeout(() => {
                    this.slide3anmate.animate4 = 1;
                }, 800);
                this.clearslide3();
            },
            slide3animateback() {
                setTimeout(() => {
                    this.slide3anmate.animate1 = 2;
                }, 200);
                setTimeout(() => {
                    this.slide3anmate.animate2 = 2;
                }, 400);
                setTimeout(() => {
                    this.slide3anmate.animate3 = 2;
                }, 600);
                setTimeout(() => {
                    this.slide3anmate.animate4 = 2;
                }, 800);
                this.clearslide3();

            },
            clearslide3() {
                this.slide3anmate.animate1 = 0;
                this.slide3anmate.animate2 = 0;
                this.slide3anmate.animate3 = 0;
                this.slide3anmate.animate4 = 0;
            },
            //slide4
            slide4animate() {
                setTimeout(() => {
                    this.slide4anmate.animate1 = 1;
                }, 200);
                setTimeout(() => {
                    this.slide4anmate.animate2 = 1;
                }, 400);
                setTimeout(() => {
                    this.slide4anmate.animate3 = 1;
                }, 600);
                setTimeout(() => {
                    this.slide4anmate.animate4 = 1;
                }, 800);
                this.clearslide4();
            },
            slide4animateback() {
                setTimeout(() => {
                    this.slide4anmate.animate1 = 2;
                }, 200);
                setTimeout(() => {
                    this.slide4anmate.animate2 = 2;
                }, 400);
                setTimeout(() => {
                    this.slide4anmate.animate3 = 2;
                }, 600);
                setTimeout(() => {
                    this.slide4anmate.animate4 = 2;
                }, 800);
                this.clearslide4();
            },
            clearslide4() {
                this.slide4anmate.animate1 = 0;
                this.slide4anmate.animate2 = 0;
                this.slide4anmate.animate3 = 0;
                this.slide4anmate.animate4 = 0;
            },
            //slide5
            slide5animate() {
                setTimeout(() => {
                    this.slide5anmate.animate1 = 1;
                }, 200);
                setTimeout(() => {
                    this.slide5anmate.animate2 = 1;
                }, 400);
                setTimeout(() => {
                    this.slide5anmate.animate3 = 1;
                }, 600);
                setTimeout(() => {
                    this.slide5anmate.animate4 = 1;
                }, 800);
                this.clearslide5();
            },
            slide5animateback() {
                setTimeout(() => {
                    this.slide5anmate.animate1 = 2;
                }, 200);
                setTimeout(() => {
                    this.slide5anmate.animate2 = 2;
                }, 400);
                setTimeout(() => {
                    this.slide5anmate.animate3 = 2;
                }, 600);
                setTimeout(() => {
                    this.slide5anmate.animate4 = 2;
                }, 800);
                this.clearslide5();

            },
            clearslide5() {
                this.slide5anmate.animate1 = 0;
                this.slide5anmate.animate2 = 0;
                this.slide5anmate.animate3 = 0;
                this.slide5anmate.animate4 = 0;
            },
            //slide6
            slide6animate() {
                setTimeout(() => {
                    this.slide6anmate.animate1 = 1;
                }, 200);
                setTimeout(() => {
                    this.slide6anmate.animate2 = 1;
                }, 400);
                setTimeout(() => {
                    this.slide6anmate.animate3 = 1;
                }, 600);
                setTimeout(() => {
                    this.slide6anmate.animate4 = 1;
                }, 800);
                this.clearslide6();
            },
            slide6animateback() {
                setTimeout(() => {
                    this.slide6anmate.animate1 = 2;
                }, 200);
                setTimeout(() => {
                    this.slide6anmate.animate2 = 2;
                }, 400);
                setTimeout(() => {
                    this.slide6anmate.animate3 = 2;
                }, 600);
                setTimeout(() => {
                    this.slide6anmate.animate4 = 2;
                }, 800);
                this.clearslide6();

            },
            clearslide6() {
                this.slide6anmate.animate1 = 0;
                this.slide6anmate.animate2 = 0;
                this.slide6anmate.animate3 = 0;
                this.slide6anmate.animate4 = 0;
            },
            //slide7
            slide7animate() {
                setTimeout(() => {
                    this.slide7anmate.animate1 = 1;
                }, 200);
                setTimeout(() => {
                    this.slide7anmate.animate2 = 1;
                }, 400);
                setTimeout(() => {
                    this.slide7anmate.animate3 = 1;
                }, 600);
                setTimeout(() => {
                    this.slide7anmate.animate4 = 1;
                }, 800);
                this.clearslide7();
            },
            slide7animateback() {
                setTimeout(() => {
                    this.slide7anmate.animate1 = 2;
                }, 200);
                setTimeout(() => {
                    this.slide7anmate.animate2 = 2;
                }, 400);
                setTimeout(() => {
                    this.slide7anmate.animate3 = 2;
                }, 600);
                setTimeout(() => {
                    this.slide7anmate.animate4 = 2;
                }, 800);
                this.clearslide7();

            },
            clearslide7() {
                this.slide7anmate.animate1 = 0;
                this.slide7anmate.animate2 = 0;
                this.slide7anmate.animate3 = 0;
                this.slide7anmate.animate4 = 0;

            },

            //新闻动画
            newanimate() {

                setTimeout(() => {
                    this.newsactive.title1 = 1;
                }, 200);
                setTimeout(() => {
                    this.newsactive.title2 = 1;
                }, 350);
                setTimeout(() => {
                    this.newsactive.title3 = 1;
                }, 500);
                setTimeout(() => {
                    this.newsactive.title4 = 1;
                }, 650);
                setTimeout(() => {
                    this.newsactive.title5 = 1;
                }, 800);
                setTimeout(() => {
                    this.newsactive.title6 = 1;
                }, 950);
                setTimeout(() => {
                    this.newsactive.title7 = 1;
                }, 1100);
                this.animatecz();
            },
            //新闻列表清除动画
            animatecz() {
                this.newsactive.title1 = 0;
                this.newsactive.title2 = 0;
                this.newsactive.title3 = 0;
                this.newsactive.title4 = 0;
                this.newsactive.title5 = 0;
                this.newsactive.title6 = 0;
                this.newsactive.title7 = 0;
            },
            jumpdetail(e){
                this.$router.push({
                    path:"/newviewsdetail",
                    query:{
                        id:e
                    }
                })
            },
        },
    }
</script>

<style scoped lang='scss'>
    @import "../../public/statics/css/animate.min.css";

    .box {
        width: 100%;
        height: auto;
        /*background: #FBA962;*/

        .slide1 {
            width: 100%;
            height: 100%;
            position: relative;
            background: #2B2C44;

            .imgbox {
                position: absolute;
                /*background: #2B2C44;*/
                width: 100%;
                height: 100%;
                background-image: url("../../public/statics/img/banner.gif");

                img {
                    /*width: 24rem;*/
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                }
            }

            .indexfont {
                width: auto;
                height: 1rem;

                position: absolute;
                top: 0;
                left: 10px;
                right: 0;
                bottom:0;
                margin: auto;

                img {
                    height: 1rem;
                    width: auto;
                }
            }

            .apply {
                position: absolute;
                bottom: 3rem;
                left: 0;
                right: 0;
                margin: auto;
                width: 1.8rem;
                height: 0.4rem;
                line-height: 0.4rem;
                background: linear-gradient(to right, #80bdff, #a67fff);
                z-index: 9;
                border-radius: 50px;
                border: 1px solid #fff;
                font-size: 0.2rem;
                font-family: "PingFang SC";
                font-weight: lighter;
                letter-spacing: 2px;
                color: #fff;
                padding-left: 0.05rem;
                cursor: pointer;

                i {
                    font-size: 0.15rem;
                    font-weight: bold;
                }
            }

            .apply:active {
                opacity: 0.85;
            }

            .applys {
                position: absolute;
                top: 0;
                bottom: -2.5rem;
                left: 15px;
                right: 0;
                margin: auto;
                width: auto;
                height: 1rem;
                line-height: 0.4rem;
                border-radius: 0.4rem;
                cursor: pointer;
                img{
                    height: 100%;
                }
            }


            .slide1bot {
                position: absolute;
                width: 18rem;
                height: 1.2rem;
                left: 0;
                right: 0;
                bottom: 0.2rem;
                margin: auto;
                background: rgba(0, 0, 0, 0.4);
                color: #fff;
                display: flex;
                justify-content: space-around;
                border-radius: 4px;
                z-index: 2;

            }

            .slide1bots {
                position: absolute;
                border-radius: 4px;
                width: 18rem;
                height: 1.2rem;
                left: 0;
                right: 0;
                bottom: 0.2rem;
                margin: auto;
                color: #fff;
                display: flex;
                justify-content: space-around;
                align-items: center;
                z-index: 3;

                .slide1unit {
                    width: 5rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    font-family: "PingFang SC";

                    p {
                        font-size: 0.4rem;
                        letter-spacing: 5px;
                    }

                    span {
                        font-size: 0.2rem;
                        letter-spacing: 2px;
                        font-weight: lighter;
                    }
                }

                .slide1white {
                    width: 2px;
                    height: 0.5rem;
                    background: #ffff;
                }

            }
        }

        .sldie2 {
            width: 100%;
            height: 100%;
            position: relative;
            /*padding-top: 0.6rem;*/
            /*box-sizing: border-box;*/
            .slide2font {
                position: absolute;
                top: 3rem;
                left: 1rem;
                display: flex;
                width: 5rem;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                text-align: left;

                .sl2black {
                    width: 0.6rem;
                    height: 0.04rem;
                    background: #000;
                }

                .sl2title {
                    margin-top: 0.1rem;
                    font-size: 0.4rem;
                    font-family: "PingFang SC";

                    color: #111;
                    line-height: 0.5rem;
                }

                .sl2titles {
                    margin-top: 0.2rem;
                    font-size: 0.25rem;
                    font-family: "PingFang SC";
                    width: 100%;
                    color: #666;
                    line-height: 0.3rem;
                }

                .sl2details {
                    width: 100%;
                    margin-top: 0.2rem;
                    font-size: 0.2rem;
                    line-height: 0.25rem;
                    font-family: "PingFang SC";
                    color: #777;
                    word-wrap: break-word;
                    white-space: normal;
                    word-break: break-all;

                }
            }

            .slide2img {
                position: absolute;
                width: 17rem;
                right: 0;
                height: 100%;
                /*background: #42b983;*/
                background-image: url("../../public/statics/img/index/SAAS.png");
                background-size: cover;
                -webkit-background-size: cover;
                -o-background-size: cover;
                background-position: center 0;
            }

            .slide2imgs {
                position: absolute;
                width: 17rem;
                right: 0;
                height: 100%;
                /*background: #42b983;*/
                background-image: url("../../public/statics/img/index/5G.jpg");
                background-size: cover;
                -webkit-background-size: cover;
                -o-background-size: cover;
                background-position: center 0;
            }

        }

        .slide3 {
            width: 100%;
            height: 100%;
            position: relative;
            overflow: hidden;

            .slide3img {
                width: 24rem;
                height: 80vh;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;

                img {
                    width: 100%;
                    /*height: 100%;*/
                }
            }

            .slide3imgs {
                width: 24rem;
                height: 80vh;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: hidden;

                img {
                    width: 100%;
                    /*height: 100%;*/
                }
            }

            .slide3font {
                position: absolute;
                bottom: 0.1rem;
                left: 0;
                right: 0;
                width: 22rem;
                height: 20vh;
                margin: auto;
                display: flex;
                justify-content: space-around;
                align-items: center;
                cursor: pointer;

                .slide3fonts {
                    display: flex;
                    flex-direction: column;
                    text-align: left;

                    .slide3back {
                        width: 0.8rem;
                        height: 0.04rem;
                        background: #000;
                    }

                    .slide3title {
                        width: 3rem;
                        margin-top: 0.3rem;
                        font-size: 0.4rem;
                        font-family: "PingFang SC";

                        color: #111;
                        line-height: 0.5rem;
                    }

                    .slide3titles {
                        width: 19rem;
                        /*width: auto;*/
                        font-size: 0.25rem;
                        font-family: "PingFang SC";
                        color: #666;
                        line-height: 0.3rem;
                    }

                    .slide3details {
                        width: 19rem;
                        margin-top: 0.2rem;
                        font-size: 0.2rem;
                        line-height: 0.25rem;
                        font-family: "PingFang SC";
                        color: #777;

                    }
                }
            }
        }

        .slide4 {
            width: 100%;
            height: 100%;
            position: relative;
            overflow: hidden;

            .slide4img {
                width: 17rem;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background: #66B1E1;

                .banner {
                    width: 100%;
                    height: 100%;
                    background: #F35959;

                    .bannerunit {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                            width: 100%;
                        }
                    }

                    .swiper-button-prev {
                        background: #000000;
                        color: #Fff;
                        opacity: 0.3;
                        cursor: pointer;
                        border-radius: 4px;
                        width: 40px;
                        border: 1px solid #fff;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .swiper-button-prev:active {
                        opacity: 0.2;
                    }

                    .swiper-button-next {
                        width: 40px;
                        border-radius: 4px;
                        background: #000000;
                        color: #Fff;
                        opacity: 0.3;
                        cursor: pointer;
                        border: 1px solid #fff;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                    }

                    .swiper-button-next:active {
                        opacity: 0.2;
                    }
                }
            }

            .slide4imgs {
                width: 17rem;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background-image: url("../../public/statics/img/index/it.jpg");
                background-size: cover;
                -webkit-background-size: cover;
                -o-background-size: cover;
                background-position: center 0;
            }

            .slide4font {
                position: absolute;
                top: 3rem;
                right: 1rem;
                display: flex;
                width: 5rem;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                text-align: left;

                .slide4black {
                    width: 0.6rem;
                    height: 0.04rem;
                    background: #000;
                }

                .slide4title {
                    margin-top: 0.1rem;
                    font-size: 0.4rem;
                    font-family: "PingFang SC";

                    color: #111;
                    line-height: 0.5rem;
                }

                .slide4titles {
                    width: 100%;
                    margin-top: 0.2rem;
                    font-size: 0.25rem;
                    font-family: "PingFang SC";

                    color: #666;
                    line-height: 0.3rem;
                }

                .slide4details {
                    width: 100%;
                    margin-top: 0.2rem;
                    font-size: 0.2rem;
                    line-height: 0.25rem;
                    font-family: "PingFang SC";
                    color: #777;
                }

            }
        }



        .bottomSpans {
            cursor: pointer;

            a {
                text-decoration: none;
            }

            color: #fff;

            a:visited, a:link, a:active {
                color: #fff;
            }

            a:hover {
                color: #4f8aff;
            }
        }
    }


</style>
<style lang="scss">
    .box {
        .swiper-container {
            width: 100%;
            height: 100%;
            margin-left: auto;
            margin-right: auto;
            /*background: #2B2C44;*/
        }

        .swiper-slide {
            position: relative;
            text-align: center;
            font-size: 18px;
            background: #fff;
            width: 100%;
            height: 400px;

            .slide-fade-enter-active {
                transition: all .5s ease;
            }

            .slide-fade-leave-active {
                transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
            }

            .slide-fade-enter, .slide-fade-leave-to {
                transform: translateX(5px);
                opacity: 0;
            }

            .news {
                margin-top: 0.8rem;
                display: flex;
                flex-direction: column;
                align-items: center;

                .title {
                    font-size: 0.3rem;
                    line-height: 0.4rem;
                    color: #2B2C44;
                    font-family: "PingFang SC";
                }

                .titles {
                    font-size: 0.2rem;
                    color: #ccc;
                    font-family: "PingFang SC";
                    margin-top: 0.2rem;
                    margin-bottom: 0.2rem;

                }

                .newsb {
                    display: flex;
                    width: 20.4rem;
                    height: 6rem;
                    margin: 0.1rem auto;
                    /*background: #42b983;*/
                    justify-content: space-between;

                    .newsbl {
                        width: 10rem;
                        padding: 0.25rem;
                        box-sizing: border-box;
                        background: #f7f7f7;
                        border-radius: 4px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;

                        .newblimgbox {
                            width: 100%;
                            height: 4.45rem;
                            border-radius: 4px;
                            /*background: #FBA962;*/

                            display: flex;
                            justify-content: center;
                            align-items: center;
                            overflow: hidden;

                            img {
                                width: 100%;
                                height:auto;
                            }

                        }

                        .newbllist {
                            width: 100%;

                            display: flex;
                            justify-content: space-between;

                            .newbllist1 {
                                color: #999a95;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-around;
                                align-items: center;
                                height: 1rem;

                                p {
                                    font-size: 0.3rem;
                                }

                                .newbllist1s {
                                    width: 0.5rem;
                                    height: 1px;
                                    background: #999a95;
                                }

                                span {
                                    font-size: 0.2rem;
                                }
                            }

                            .newbllist2 {
                                width: 8.5rem;
                                display: flex;
                                /*justify-content: space-around;*/
                                flex-direction: column;
                                align-items: flex-start;

                                p {
                                    color: #737476;
                                    line-height: 0.3rem;
                                    font-size: 0.25rem;
                                    width: 100%;
                                    height: 0.3rem;
                                    margin-top: 0.2rem;
                                    white-space: nowrap;
                                    text-overflow: ellipsis; /* for internet explorer */
                                    overflow: hidden;
                                    text-align: left;
                                    font-family: "PingFang SC";

                                }

                                span {
                                    line-height: 0.3rem;
                                    font-size: 0.2rem;
                                    letter-spacing: 1px;
                                    width: 100%;
                                    height: 0.3rem;
                                    margin-top: 0.1rem;
                                    color: #999999;
                                    white-space: nowrap;
                                    text-overflow: ellipsis; /* for internet explorer */
                                    overflow: hidden;
                                }

                            }


                        }


                    }

                    .newsbr {
                        width: 10rem;
                        background: #ffffff;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;

                        .newsbrunit {
                            width: 10rem;
                            height: 1rem;
                            display: flex;
                            justify-content: space-around;
                            background: #f7f7f7;
                            border-radius: 4px;
                            box-sizing: border-box;
                            padding: 10px;

                            .newbllist1 {
                                color: #999a95;
                                display: flex;
                                flex-direction: column;
                                justify-content: space-around;
                                align-items: center;
                                height: 100%;

                                p {
                                    font-size: 0.3rem;

                                }

                                .newbllist1s {
                                    width: 0.5rem;
                                    height: 1px;
                                    background: #999a95;
                                }

                                span {
                                    font-size: 0.2rem;

                                }
                            }

                            .newbllist2 {
                                width: 8.5rem;
                                display: flex;
                                /*justify-content: space-around;*/
                                flex-direction: column;
                                align-items: flex-start;

                                p {
                                    color: #737476;
                                    line-height: 0.3rem;
                                    font-size: 0.2rem;
                                    width: 100%;
                                    text-align: left;
                                    height: 0.3rem;
                                    margin-top: 0.1rem;
                                    white-space: nowrap;
                                    text-overflow: ellipsis; /* for internet explorer */
                                    overflow: hidden;
                                    font-family: "PingFang SC";

                                }

                                span {
                                    color: #999999;
                                    font-size: 0.18rem;
                                    line-height: 0.2rem;
                                    width: 100%;
                                    letter-spacing: 1px;
                                    margin-top: 0.05rem;
                                    height: 0.2rem;
                                    white-space: nowrap;
                                    text-overflow: ellipsis; /* for internet explorer */
                                    overflow: hidden;
                                }

                            }
                        }

                    }
                }

                .more {
                    width: 2rem;
                    height: 0.4rem;
                    border-radius: 4px;
                    border: 1px solid #666;
                    line-height: 0.4rem;
                    color: #666;
                    margin-top: 0.5rem;
                    cursor: pointer;
                }

                .more:active {
                    color: #333;
                    border: 1px solid #333;
                }

            }

            .bottoms {
                position: absolute;
                bottom: 0;

                img {
                    width: 100%;
                    height: 2rem;
                }

                .botnic {
                    position: absolute;
                    top: 0.5rem;
                    left: 0;
                    right: 0;
                    margin: auto;

                    .botsbut {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .botsbut1 {
                            width: 1.6rem;
                            height: 0.4rem;
                            border-radius: 60px;
                            border: 1px solid #fff;
                            text-align: center;
                            line-height: 0.4rem;
                            font-size: 0.2rem;
                            color: #ffffff;
                            /*margin-right: 0.2rem;*/
                            letter-spacing: 2px;
                            cursor: pointer;
                            font-family: "PingFang SC";
                            font-weight: lighter;

                            margin-top: 0.2rem;

                        }

                        .botsbut2 {
                            width: 1.6rem;
                            height: 0.4rem;
                            border-radius: 60px;
                            border: 1px solid #fff;
                            text-align: center;
                            line-height: 0.4rem;
                            font-size: 0.2rem;
                            color: #ffffff;
                            margin-left: 0.2rem;
                            letter-spacing: 2px;
                            cursor: pointer;
                        }

                        .botsbut1:active, .botsbut2:active {
                            color: #f5f5f5;
                            border: 1px solid #f5f5f5;
                        }
                    }

                    .botsfont {
                        font-family: "PingFang SC";
                        margin-top: 0.35rem;
                        width: 100%;
                        height: 0.4rem;
                        line-height: 0.4rem;
                        font-size: 0.15rem;
                        color: #fff;
                        font-weight: lighter;
                    }
                }

            }
        }


        .swiper-scrollbar {
            margin-top: 0.6rem;
            height: calc(100% - 0.8rem) !important;
            background: rgba(204, 204, 204, 0.5);
            width: 12px !important;
        }

        .swiper-scrollbar-drag {
            background: #01415d !important;
        }
    }
</style>